module.exports = __webpack_public_path__ + "img/manulife-men-on-laptop..f6c4b39e.png";